import { put, call, takeEvery } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import { replace } from "react-router-redux";
import axios from "axios";

import { logoutRequest } from "../../login/actions";

import {
  ADD_PLAYLIST_REQUEST,
  addPlaylistSuccess,
  addPlaylistError,
} from "./actions";
import { Env } from "../../../env";

function* addPlaylistRequest(action) {
  const { userId, accessToken, values, videos } = action;
  let response;

  try {
    response = yield call(
      axios.post,
      `${Env.BASE_API_URL}/Accounts/${userId}/Playlists`,
      {
        ...values,
        videos,
      },
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    if (err.response && err.response.status === 400) {
      yield put(addPlaylistError());
      yield put(flashMessage("Erreur, veuillez vérifier vos informations."));
    } else if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(addPlaylistError());
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }

  yield put(addPlaylistSuccess(response.data));

  yield put(flashMessage("Nouvelle playlist créée avec succès."));

  yield put(replace("/playlists"));
}

export default function* watchAddPlaylistRequest() {
  yield takeEvery(ADD_PLAYLIST_REQUEST, addPlaylistRequest);
}



// WEBPACK FOOTER //
// ./src/pages/playlists/add/saga.js